import styled, { CSSProp } from 'styled-components'

interface CountrySelectorFlagPlaceholderUiProps {
  disabled?: boolean
  styles?: CSSProp
}

export const CountrySelectorFlagPlaceholderUi = styled.div<CountrySelectorFlagPlaceholderUiProps>`
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  margin: 0 4px;
  border-radius: 3px;
  background-color: #d9d9d9;

  ${({ disabled }) => (disabled ? `opacity: 0.75;` : '')}
  ${({ styles }) => styles}
`
